import React from 'react';
import {
  SwipeableDrawer as MuiDrawer,
  SwipeableDrawerProps as MuiSwipeableDrawerProps,
  IconButton as MuiIconButton,
  Paper as MuiPaper,
  Typography
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Close } from '@material-ui/icons';

const CloseButton = withStyles({
  root: {
    position: 'absolute',
    top: 0,
    left: 0
  }
})(MuiIconButton);

const StyledDrawer = withStyles({
  paper: {
    borderRadius: "25px 25px 0 0",
    maxHeight: '90vh',
    overflow: 'hidden',
  },
})(MuiDrawer);

const Paper = withStyles({
  root: {
    borderRadius: "25px 25px 0 0",
  },
})(MuiPaper);

interface DrawerProps {
  closeIcon?: React.ReactNode;
  closeLabel?: string;
  onClose: React.MouseEventHandler<HTMLButtonElement>;
  open: boolean;
}

export type SwipeableDrawerProps =
  & DrawerProps
  & React.PropsWithChildren<{}>
  & Omit<MuiSwipeableDrawerProps, 'onOpen'>;

const SwipeableDrawer = ({
  children, 
  closeIcon = <Close />,
  closeLabel = 'Close', 
  onClose, 
  open,
}: SwipeableDrawerProps) => (
  <StyledDrawer
    anchor='bottom'
    disableSwipeToOpen
    elevation={10}
    hideBackdrop
    keepMounted
    open={open}
    onClose={onClose}
    onOpen={() => {}}
    ModalProps={{ 
      BackdropProps: {
        invisible: true,
        style: {
          position: 'relative',
        },
      },
    }}
    style={{
      position: 'relative'
    }}
    variant='temporary'
  >
    <Paper variant='outlined'>
      {children}
    </Paper>
    <CloseButton onClick={onClose}>
      <Typography variant='srOnly'>{closeLabel}</Typography>
      {closeIcon}
    </CloseButton>
  </StyledDrawer>
);

export default SwipeableDrawer;
